export enum InventoryPageType {
  MY_ITEMS = 'MY_ITEMS',
  SHARED_WITH_ME = 'SHARED_WITH_ME',
}
